// extracted by mini-css-extract-plugin
export default {"melodyVideo":"nK-z","isFullWidth":"oK-z","landingPageVideo":"pK-z","play":"qK-z","iframeVideo":"rK-z","playHidden":"sK-z","fullwidth":"tK-z"};